import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

interface TodayChatResponse {
	chatId: string;
	messages: Array<{
		id: string;
		role: string;
		content: string | Array<{ text?: string }>;
		createdAt: string;
	}>;
	isNew: boolean;
}

export function useTodayChat(options?: {
	forceNew?: boolean;
	enabled?: boolean;
}) {
	const { user: auth0User } = useAuth0();
	const forceNew = options?.forceNew ?? false;
	const enabled = options?.enabled ?? true;

	return useQuery<TodayChatResponse>({
		queryKey: ["chat", "today", forceNew],
		queryFn: async () => {
			const url = forceNew
				? "/api/chat/today?forceNew=true"
				: "/api/chat/today";
			const response = await api.get(url);
			return response.data;
		},
		enabled: !!auth0User && enabled,
		staleTime: 5 * 60 * 1000,
		gcTime: Number.POSITIVE_INFINITY,
		refetchOnWindowFocus: false,
	});
}

export type { TodayChatResponse };
